module.exports = __webpack_public_path__ + "static/media/outside-link.63d46574.svg";